var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oups, nothing there! The page you are looking for does not exist.")]),_c('router-link',{staticClass:"back-home",attrs:{"to":"/"}},[_vm._v("Back")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }